module.exports = __webpack_public_path__ + "static/solution1-9b85d18b085b4146cd5242643b3c5515.png";